/**
 * Last-resort recovery screen rendered by the top-level ErrorBoundary in
 * `index.tsx`. Inline markup only — it must never depend on a lazy chunk, since
 * the most common failure it handles is a chunk that won't load.
 */
export const RootErrorFallback = () => (
  <div
    role="alert"
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      padding: '40px 20px',
      textAlign: 'center',
    }}
  >
    <h2 style={{ color: '#c00', fontSize: '20px' }}>Щось пішло не так</h2>
    <p style={{ color: '#666', fontSize: '14px', maxWidth: '480px' }}>
      Не вдалося завантажити сторінку. Спробуйте оновити.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        background: '#004795',
        color: '#fff',
        border: 'none',
        borderRadius: '50px',
        padding: '10px 20px',
        fontSize: '14px',
        cursor: 'pointer',
      }}
    >
      Оновити сторінку
    </button>
  </div>
);
